import PageContainer from './page-container.styles';

export default PageContainer;
